import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import styled from 'styled-components';

import useWindowDimensions from '../../../hooks/windowDimensions';
import PopupModal from '../../PopupModal/PopupModal';
import classes from '../../UIHeader/Header.module.css';
import VideoTutorial from '../../VideoTutorial/VideoTutorial';
import { Block } from '../StyledComponents';

const Header = (props) => {
  const { clientName } = props;
  const currentDeal = useSelector((state) => state?.comRed?.currentDeal);

  const { width, height } = useWindowDimensions();

  const [isModalOpen, setIsmodalOpen] = useState(false);
  const showVideo = (event) => {
    event.preventDefault();
    setIsmodalOpen(true);
  };
  const closeModal = () => {
    setIsmodalOpen(false);
  };

  return (
    <HeaderContainer>
      <HeaderElementsContainer>
        <Block display="flex" justifyContent="space-between" alignItems="center" flex="1 1 100%">
          <Block alignItems="center">
            <LogoText>Agile Real Estate Solutions for {currentDeal?.['Client Name']?.[0]}</LogoText>
          </Block>
          <HelpIcon
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <div className={classes.infolink} onClick={showVideo} title="Help"></div>
          </HelpIcon>
        </Block>
        {isModalOpen && (
          <PopupModal open={isModalOpen} onClose={closeModal}>
            <VideoTutorial
              url="https://scribehow.com/shared/Edit_Client_Deliverable_feature_for_Local_Brokers__RVeqKNSvQMGDIGd6kSrYAQ"
              width={width / 2}
              height={height - 268}
            ></VideoTutorial>
          </PopupModal>
        )}
      </HeaderElementsContainer>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  background: #012a2d;
  width: 100%;
  height: 70px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.14);
`;

const HeaderElementsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 51px 0px 22px;
`;

const UserIcon = styled.div`
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Calibre-R';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  cursor: pointer;
`;

const LogoText = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  color: #fff;
`;

const Image = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;
const HelpIcon = styled.div`
  display: 'flex';
  justifycontent: 'flex-start';
  alignitems: 'center';
`;

export default Header;
